// Utility functions for event wizard

const isTrialRunning = (organizationDoc) => {
  if (!organizationDoc?.trialSubscription) return false;

  const trialStart = new Date(organizationDoc?.trialSubscription?.start);
  const trialEnd = new Date(organizationDoc?.trialSubscription?.end);
  const now = new Date();

  const isTrialRunning = trialStart < now && now < trialEnd ? true : false;

  return isTrialRunning;
};

export default isTrialRunning;
